"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.creditCheckTextSchema = void 0;
exports.creditCheckTextSchema = {
    type: ['object', 'null'],
    required: [
        'cmhcAccountNumber',
        'typeID',
        'activeHelocTradesLastTwelveMonthCount',
        'activeInstallmentTradeTwelveMonthCount',
        'activeTradeTwelveMonthCount',
        'automotiveTradesUsedEightyPercent',
        'automotiveTradesUsedFiftyPercent',
        'automotiveTradesUsedHundredPercent',
        'automotiveTradesUsedNinetyPercent',
        'automotiveTradesUsedThirtyPercent',
        'averageMonthActiveAutomotiveTradesCount',
        'averageMonthActiveInstallmentTradesCount',
        'averageMonthActiveTradesCount',
        'bankruptcyDischargeDate',
        'firstTradeOpenDate',
        'firstTradeSinceBackReportDate',
        'helocTradesCreditLimitAmount',
        'helocTradesOutstandingBalanceAmount',
        'installmentTradesUsedEightyPercent',
        'installmentTradesUsedFiftyPercent',
        'installmentTradesUsedHundredPercent',
        'installmentTradesUsedNinetyPercent',
        'installmentTradesUsedThirtyPercent',
        'lastInquiryDayCount',
        'lastUnfavourableCreditRatingPeriodText',
        'mortgageTradesOutstandingBalanceLastTwelveMonthAmount',
        'mostRecentCollectionDate',
        'mostRecentJudgmentDate',
        'openTradeCount',
        'recordCreatedTimestamp',
        'recordUpdatedTimestamp',
        'recordUpdatedUserID',
        'revolvingTradeOpenCount',
        'revolvingTradesActiveInTwelveMonthsCount',
        'revolvingTradesUsedEightyPercent',
        'revolvingTradesUsedFiftyPercent',
        'revolvingTradesUsedHundredPercent',
        'revolvingTradesUsedNinetyPercent',
        'revolvingTradesUsedThirtyPercent',
        'totalOpenInstallmentTradeCount',
    ],
    properties: {
        cmhcAccountNumber: {
            type: 'number',
            minimum: 0,
            maximum: 999999999999,
            errorMessage: 'should be an integer between 0 and 999999999999',
        },
        typeID: {
            type: 'integer',
            minimum: 0,
            maximum: 32767,
            errorMessage: 'should be an integer between 0 and 32767',
        },
        cmhcApplicantID: {
            type: 'string',
            format: 'uuid',
            errorMessage: 'should follow UUID format 00000000-0000-0000-0000-000000000000',
        },
        activeHelocTradesLastTwelveMonthCount: {
            type: 'string',
            truncate: true,
            minLength: 0,
            maxLength: 3,
            errorMessage: 'should have maximum length of 3 characters',
        },
        activeInstallmentTradeTwelveMonthCount: {
            type: 'string',
            truncate: true,
            minLength: 0,
            maxLength: 3,
            errorMessage: 'should have maximum length of 3 characters',
        },
        activeMortgageTradesLastTwelveMonthCount: {
            type: ['string', 'null'],
            truncate: true,
            minLength: 0,
            maxLength: 3,
            errorMessage: 'should have maximum length of 3 characters or null',
        },
        activeTradeTwelveMonthCount: {
            type: 'string',
            truncate: true,
            minLength: 0,
            maxLength: 3,
            errorMessage: 'should have maximum length of 3 characters',
        },
        allRevolvingTradesUtilizationPercent: {
            type: ['string', 'null'],
            truncate: true,
            minLength: 0,
            maxLength: 5,
            errorMessage: 'should have maximum length of 5 characters or null',
        },
        automotiveTradesMostRecentOpenMonthCount: {
            type: ['string', 'null'],
            truncate: true,
            minLength: 0,
            maxLength: 3,
            errorMessage: 'should have maximum length of 3 characters or null',
        },
        automotiveTradesUsedEightyPercent: {
            type: 'string',
            truncate: true,
            minLength: 0,
            maxLength: 3,
            errorMessage: 'should have maximum length of 3 characters',
        },
        automotiveTradesUsedFiftyPercent: {
            type: 'string',
            truncate: true,
            minLength: 0,
            maxLength: 3,
            errorMessage: 'should have maximum length of 3 characters',
        },
        automotiveTradesUsedHundredPercent: {
            type: 'string',
            truncate: true,
            minLength: 0,
            maxLength: 3,
            errorMessage: 'should have maximum length of 3 characters',
        },
        automotiveTradesUsedNinetyPercent: {
            type: 'string',
            truncate: true,
            minLength: 0,
            maxLength: 3,
            errorMessage: 'should have maximum length of 3 characters',
        },
        automotiveTradesUsedThirtyPercent: {
            type: 'string',
            truncate: true,
            minLength: 0,
            maxLength: 3,
            errorMessage: 'should have maximum length of 3 characters',
        },
        automotiveTradesUtilizationPercent: {
            type: ['string', 'null'],
            truncate: true,
            minLength: 0,
            maxLength: 5,
            errorMessage: 'should have maximum length of 5 characters or null',
        },
        averageMonthActiveAutomotiveTradesCount: {
            type: 'string',
            truncate: true,
            minLength: 0,
            maxLength: 3,
            errorMessage: 'should have maximum length of 3 characters',
        },
        averageMonthActiveInstallmentTradesCount: {
            type: 'string',
            truncate: true,
            minLength: 0,
            maxLength: 3,
            errorMessage: 'should have maximum length of 3 characters',
        },
        averageMonthActiveTradesCount: {
            type: 'string',
            truncate: true,
            minLength: 0,
            maxLength: 3,
            errorMessage: 'should have maximum length of 3 characters',
        },
        averageRevolvingTradesActiveMonthCount: {
            type: ['string', 'null'],
            truncate: true,
            minLength: 0,
            maxLength: 3,
            errorMessage: 'should have maximum length of 3 characters or null',
        },
        bankruptcyDischargeDate: {
            type: 'string',
            truncate: true,
            minLength: 0,
            maxLength: 6,
            errorMessage: 'should have maximum length of 6 characters',
        },
        creditInquiriesInLastThreeMonthsCount: {
            type: ['string', 'null'],
            truncate: true,
            minLength: 0,
            maxLength: 2,
            errorMessage: 'should have maximum length of 2 characters or null',
        },
        creditInquiriesInLastTwelveMonthsCount: {
            type: ['string', 'null'],
            truncate: true,
            minLength: 0,
            maxLength: 2,
            errorMessage: 'should have maximum length of 2 characters or null',
        },
        firstTradeOpenDate: {
            type: 'string',
            truncate: true,
            minLength: 0,
            maxLength: 6,
            errorMessage: 'should have maximum length of 6 characters',
        },
        firstTradeSinceBackReportDate: {
            type: 'string',
            truncate: true,
            minLength: 0,
            maxLength: 6,
            errorMessage: 'should have maximum length of 6 characters',
        },
        firstWorstTradePastDueRatingCode: {
            type: ['string', 'null'],
            truncate: true,
            minLength: 0,
            maxLength: 2,
            errorMessage: 'should have maximum length of 2 characters or null',
        },
        helocTradeMortgageRatedThreeOrWorseMonthCount: {
            type: ['string', 'null'],
            truncate: true,
            minLength: 0,
            maxLength: 3,
            errorMessage: 'should have maximum length of 3 characters or null',
        },
        helocTradeOldestMortgageTradeDate: {
            type: ['string', 'null'],
            truncate: true,
            minLength: 0,
            maxLength: 6,
            errorMessage: 'should have maximum length of 6 characters or null',
        },
        helocTradesCreditLimitAmount: {
            type: 'string',
            truncate: true,
            minLength: 0,
            maxLength: 15,
            errorMessage: 'should have maximum length of 15 characters',
        },
        helocTradesOutstandingBalanceAmount: {
            type: 'string',
            truncate: true,
            minLength: 0,
            maxLength: 15,
            errorMessage: 'should have maximum length of 15 characters',
        },
        helocTradeWorstMortgagePastDueDate: {
            type: ['string', 'null'],
            truncate: true,
            minLength: 0,
            maxLength: 6,
            errorMessage: 'should have maximum length of 6 characters or null',
        },
        helocTradeYoungestMortgageLastTwelveMonthDate: {
            type: ['string', 'null'],
            truncate: true,
            minLength: 0,
            maxLength: 6,
            errorMessage: 'should have maximum length of 6 characters or null',
        },
        installmentTradesMostRecentOpenMonthCount: {
            type: ['string', 'null'],
            truncate: true,
            minLength: 0,
            maxLength: 3,
            errorMessage: 'should have maximum length of 3 characters or null',
        },
        installmentTradesUsedEightyPercent: {
            type: 'string',
            truncate: true,
            minLength: 0,
            maxLength: 3,
            errorMessage: 'should have maximum length of 3 characters',
        },
        installmentTradesUsedFiftyPercent: {
            type: 'string',
            truncate: true,
            minLength: 0,
            maxLength: 3,
            errorMessage: 'should have maximum length of 3 characters',
        },
        installmentTradesUsedHundredPercent: {
            type: 'string',
            truncate: true,
            minLength: 0,
            maxLength: 3,
            errorMessage: 'should have maximum length of 3 characters',
        },
        installmentTradesUsedNinetyPercent: {
            type: 'string',
            truncate: true,
            minLength: 0,
            maxLength: 3,
            errorMessage: 'should have maximum length of 3 characters',
        },
        installmentTradesUsedThirtyPercent: {
            type: 'string',
            truncate: true,
            minLength: 0,
            maxLength: 3,
            errorMessage: 'should have maximum length of 3 characters',
        },
        installmentTradesUtilizationPercent: {
            type: ['string', 'null'],
            truncate: true,
            minLength: 0,
            maxLength: 5,
            errorMessage: 'should have maximum length of 5 characters or null',
        },
        lastInquiryDayCount: {
            type: 'string',
            truncate: true,
            minLength: 0,
            maxLength: 3,
            errorMessage: 'should have maximum length of 3 characters',
        },
        lastUnfavourableCreditRatingPeriodText: {
            type: 'string',
            truncate: true,
            minLength: 0,
            maxLength: 4,
            errorMessage: 'should have maximum length of 4 characters',
        },
        mortgageOrHelocTradeWorstLastTwelveMonthCode: {
            type: ['string', 'null'],
            truncate: true,
            minLength: 0,
            maxLength: 2,
            errorMessage: 'should have maximum length of 2 characters or null',
        },
        mortgageOrHelocWorstRatingCode: {
            type: ['string', 'null'],
            truncate: true,
            minLength: 0,
            maxLength: 2,
            errorMessage: 'should have maximum length of 2 characters or null',
        },
        mortgageTradesOutstandingBalanceLastTwelveMonthAmount: {
            type: 'string',
            truncate: true,
            minLength: 0,
            maxLength: 15,
            errorMessage: 'should have maximum length of 15 characters',
        },
        mostRecentCollectionDate: {
            type: 'string',
            truncate: true,
            minLength: 0,
            maxLength: 6,
            errorMessage: 'should have maximum length of 6 characters',
        },
        mostRecentJudgmentDate: {
            type: 'string',
            truncate: true,
            minLength: 0,
            maxLength: 6,
            errorMessage: 'should have maximum length of 6 characters',
        },
        openTradeCount: {
            type: 'string',
            truncate: true,
            minLength: 0,
            maxLength: 3,
            errorMessage: 'should have maximum length of 3 characters',
        },
        publicRecordDelinquentCount: {
            type: ['string', 'null'],
            truncate: true,
            minLength: 0,
            maxLength: 2,
            errorMessage: 'should have maximum length of 2 characters or null',
        },
        recordCreatedTimestamp: {
            type: 'string',
            pattern: '^(\\d{4}-\\d{2}-\\d{2})(-| )(\\d{2})(:|.)(\\d{2})(:|.)(\\d{2})(.)(\\d{1,6})$',
            errorMessage: 'should have date-time format YYYY-MM-DD 00:00:00.000000, YYYY-MM-DD 00.00.00.000000, YYYY-MM-DD-00.00.00.000000',
        },
        recordUpdatedTimestamp: {
            type: 'string',
            pattern: '^(\\d{4}-\\d{2}-\\d{2})(-| )(\\d{2})(:|.)(\\d{2})(:|.)(\\d{2})(.)(\\d{1,6})$',
            errorMessage: 'should have date-time format YYYY-MM-DD 00:00:00.000000, YYYY-MM-DD 00.00.00.000000, YYYY-MM-DD-00.00.00.000000',
        },
        recordUpdatedUserID: {
            type: 'string',
            truncate: true,
            minLength: 0,
            maxLength: 8,
            errorMessage: 'should have maximum length of 8 characters',
        },
        revolvingDebtBurdenPercent: {
            type: ['string', 'null'],
            truncate: true,
            minLength: 0,
            maxLength: 5,
            errorMessage: 'should have maximum length of 5 characters or null',
        },
        revolvingTradeOpenCount: {
            type: 'string',
            truncate: true,
            minLength: 0,
            maxLength: 3,
            errorMessage: 'should have maximum length of 3 characters',
        },
        revolvingTradesActiveInTwelveMonthsCount: {
            type: 'string',
            truncate: true,
            minLength: 0,
            maxLength: 3,
            errorMessage: 'should have maximum length of 3 characters',
        },
        revolvingTradesMostRecentOpenMonthCount: {
            type: ['string', 'null'],
            truncate: true,
            minLength: 0,
            maxLength: 3,
            errorMessage: 'should have maximum length of 3 characters or null',
        },
        revolvingTradesMostUsedPercent: {
            type: ['string', 'null'],
            truncate: true,
            minLength: 0,
            maxLength: 5,
            errorMessage: 'should have maximum length of 5 characters or null',
        },
        revolvingTradesUsedEightyPercent: {
            type: 'string',
            truncate: true,
            minLength: 0,
            maxLength: 3,
            errorMessage: 'should have maximum length of 3 characters',
        },
        revolvingTradesUsedFiftyPercent: {
            type: 'string',
            truncate: true,
            minLength: 0,
            maxLength: 3,
            errorMessage: 'should have maximum length of 3 characters',
        },
        revolvingTradesUsedHundredPercent: {
            type: 'string',
            truncate: true,
            minLength: 0,
            maxLength: 3,
            errorMessage: 'should have maximum length of 3 characters',
        },
        revolvingTradesUsedNinetyPercent: {
            type: 'string',
            truncate: true,
            minLength: 0,
            maxLength: 3,
            errorMessage: 'should have maximum length of 3 characters',
        },
        revolvingTradesUsedThirtyPercent: {
            type: 'string',
            truncate: true,
            minLength: 0,
            maxLength: 3,
            errorMessage: 'should have maximum length of 3 characters',
        },
        totalCollectionsCount: {
            type: ['string', 'null'],
            truncate: true,
            minLength: 0,
            maxLength: 3,
            errorMessage: 'should have maximum length of 3 characters or null',
        },
        totalJudgmentCount: {
            type: ['string', 'null'],
            truncate: true,
            minLength: 0,
            maxLength: 3,
            errorMessage: 'should have maximum length of 3 characters or null',
        },
        totalOpenInstallmentTradeCount: {
            type: 'string',
            truncate: true,
            minLength: 0,
            maxLength: 3,
            errorMessage: 'should have maximum length of 3 characters',
        },
        totalPastDueAmount: {
            type: ['string', 'null'],
            truncate: true,
            minLength: 0,
            maxLength: 15,
            errorMessage: 'should have maximum length of 15 characters or null',
        },
        worstCurrentCreditRatingCode: {
            type: ['string', 'null'],
            truncate: true,
            minLength: 0,
            maxLength: 2,
            errorMessage: 'should have maximum length of 2 characters or null',
        },
        worstEverCreditRatingCode: {
            type: ['string', 'null'],
            truncate: true,
            minLength: 0,
            maxLength: 2,
            errorMessage: 'should have maximum length of 2 characters or null',
        },
        worstFirstTradePastDueDate: {
            type: ['string', 'null'],
            truncate: true,
            minLength: 0,
            maxLength: 6,
            errorMessage: 'should have maximum length of 6 characters or null',
        },
    },
};
exports.default = exports.creditCheckTextSchema;
